export default "__VITE_ASSET__BR54mXc2__"